<script lang="ts">
	import wheel from '$lib/assets/images/holding_wheel.png';
	import { quizOpen } from '$lib/index.svelte';
</script>

<section id="quiz" class="flex min-h-screen items-center justify-center">
	<div class="my-30 flex h-full w-full flex-col items-center justify-center">
		<h2 class="text-center text-[28px] uppercase md:text-[2rem]">Take the Quiz</h2>
		<p class="mt-3 mb-10 max-w-140 text-center text-xl leading-[130%] tracking-percent">
			Not sure who to choose?<br />
			Answer a few quick questions and we’ll match you with the Maître Fromager who best fits your taste,
			personality, and expectations.
		</p>

		<div class="relative">
			<div
				class="flex aspect-square w-140 max-w-[calc(100vw-2rem)] items-end overflow-hidden md:max-w-[calc(100vw-8rem)]"
			>
				<img src={wheel} alt="" />
			</div>
			<button
				class="md:w-unset absolute top-1/2 left-1/2 w-54.5 -translate-x-1/2 -translate-y-1/2 rounded-sm bg-white px-6 py-5 text-xl font-bold text-black uppercase"
				onclick={() => {
					quizOpen.status = true;
				}}
				>Start the Quiz
			</button>
		</div>
	</div>
</section>
